import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

export function formatViews(v: number): string {
  if (v >= 1000000) return `${(v / 1000000).toFixed(1)}万`;
  if (v >= 10000) return `${(v / 10000).toFixed(0)}万`;
  return `${v}`;
}

export default function ComicCard({ comic, rank }: { comic: Comic; rank?: number }) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group flex cursor-pointer flex-col overflow-hidden rounded-xl border border-background-800 bg-background-900 transition-all duration-300 hover:-translate-y-1 hover:border-primary-500/40"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title}漫画封面`}
          title={`${comic.title} · ${comic.categoryName}漫画`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent" />
        {rank !== undefined && (
          <span
            className={`absolute left-2.5 top-2.5 flex h-7 w-7 items-center justify-center rounded-lg font-heading text-sm font-bold ${
              rank < 3 ? "bg-accent-500 text-background-950" : "bg-background-950/80 text-primary-400"
            }`}
          >
            {rank + 1}
          </span>
        )}
        <span className="absolute right-2.5 top-2.5 rounded-md bg-background-950/80 px-2 py-1 text-[11px] font-medium text-primary-400">
          {comic.categoryName}
        </span>
        <span
          className={`absolute bottom-2.5 left-2.5 rounded-md px-2 py-1 text-[11px] font-medium ${
            comic.status === "已完结" ? "bg-accent-500 text-background-950" : "bg-primary-500/90 text-background-950"
          }`}
        >
          {comic.status}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3.5 md:p-4">
        <h3 className="truncate font-heading text-sm font-bold text-foreground-950 md:text-base">{comic.title}</h3>
        <p className="mt-1.5 line-clamp-2 min-h-[2rem] text-xs leading-5 text-foreground-600 md:text-sm">
          {comic.description}
        </p>
        <div className="mt-auto flex items-center justify-between pt-3 text-xs text-foreground-500">
          <span className="truncate">{comic.latestChapter}</span>
          <span className="flex shrink-0 items-center gap-1 text-primary-400">
            <i className="ri-star-fill text-[11px]" />
            {comic.rating}
          </span>
        </div>
      </div>
    </Link>
  );
}